import { useCallback, useEffect, useState } from 'react';
import sessionsApi from 'Api/axios/sessions-api';

/**
 * Single responsibility: own the precomputed attendance stats for ONE session.
 * Backend formula:
 *   attendancePercentage = round((present + justified) / totalExpected * 100)
 *
 * The frontend renders the result; no aggregation, no client-side recompute.
 */
export default function useSessionStatsApi({ sessionId, init = true } = {}) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async () => {
    if (!sessionId) return null;
    setLoading(true);
    setError(null);
    const response = await sessionsApi.getSessionStats(sessionId);
    if (response.error) {
      setError(response.error);
      setStats(null);
    } else {
      setStats(response.data || null);
    }
    setLoading(false);
    return response;
  }, [sessionId]);

  useEffect(() => {
    if (init && sessionId) fetchStats();
  }, [sessionId, init, fetchStats]);

  return { stats, loading, error, fetchStats };
}
